/**
 * Method which converts name of Sitecore colour field to CSS modifier class name.
 * @param {string} - name of colour variant from Sitecore field
 * @returns {string} return name of corresponding CSS modifier class
 */
export const getColourVariant = colour => {
  let colourVariant;
  const defaultColourVariant = "chatbot--coral-icon-bg";
  if (colour === "undefined" || null) {
    return defaultColourVariant;
  }
  switch (colour) {
    case "AquaNoBackground":
      {
        colourVariant = "chatbot--aqua-no-bg";
        break;
      }
    case "AquaIconBackground":
      {
        colourVariant = "chatbot--aqua-icon-bg";
        break;
      }
    case "NavyNoBackground":
      {
        colourVariant = "chatbot--navy-no-bg";
        break;
      }
    case "NavyTextIconBackground":
      {
        colourVariant = "chatbot--navy-text-icon-bg";
        break;
      }
    case "NavyIconBackground":
      {
        colourVariant = "chatbot--navy-icon-bg";
        break;
      }
    case "CoralNoBackground":
      {
        colourVariant = "chatbot--coral-no-bg";
        break;
      }
    case "CoralTextIconBackground":
      {
        colourVariant = "chatbot--coral-text-icon-bg";
        break;
      }
    default:
      {
        colourVariant = defaultColourVariant;
      }
  }
  return colourVariant;
};

/**
 * Method which converts name of Sitecore size field to CSS modifier class name.
 * @param {string} - name of colour variant from Sitecore field
 * @returns {string} return name of corresponding CSS modifier class
 */
export const getSizeVariant = size => {
  let sizeVariant;
  const defaultSizeVariant = "chatbot--large";
  if (size === "undefined" || null) {
    return defaultSizeVariant;
  }
  switch (size) {
    case "Small":
      {
        sizeVariant = "chatbot--small";
        break;
      }
    default:
      {
        sizeVariant = defaultSizeVariant;
      }
  }
  return sizeVariant;
};

/**
 * Method which converts name of Sitecore size field to CSS modifier class name.
 * @param {string} - name of position variant from Sitecore field
 * @returns {string} return name of corresponding CSS modifier class
 */
export const getPositionVariant = position => {
  let positionVariant;
  const defaultPositionVariant = "chatbot--middle";
  if (position === "undefined" || null) {
    return defaultPositionVariant;
  }
  switch (position) {
    case "Bottom":
      {
        positionVariant = "chatbot--bottom";
        break;
      }
    default:
      {
        positionVariant = defaultPositionVariant;
      }
  }
  return positionVariant;
};